import {sessionStore} from '../../../shared/SessionStore'
import {getEnv} from '../../../shared/env'
import {getPageName} from './helpers/getPageName'

// нужно чтобы бустер ошибочно не конвертировал айдишники в числа
const prependId = (val?: string) => (val ? 'id:' + val : undefined)

if (!getEnv().LOGGER_DISABLE_RUM) {
  console.debug(`[rum] [${new Date().toISOString()}]:`, 'init_rum')

  Ya.Rum.init(
    {
      reqid: sessionStore.data.requestId,
      beacon: !!navigator.sendBeacon,
      clck: 'https://yandex.ru/clck/click',
      longTaskMetric: true,
      forcePaintTimeSending: true,
      sendUrlInResTiming: true,
      sendAutoResTiming: true,
      sendAutoElementTiming: true,
      sendFirstRaf: true,
      logClsTarget: true,
      sendClientUa: true
    },
    {
      '-project': 'eats-restapp',
      '-service': sessionStore.data.service,
      '-env': sessionStore.data.env,
      '-version': sessionStore.data.version,
      '-page': getPageName(window.location.pathname),
      '-host': window.location.host,
      '-platform': sessionStore.data.platformType,
      '-additional': JSON.stringify({
        parentRequestId: prependId(sessionStore.data.parentRequestId),
        platformVendor: sessionStore.data.platformVendor,
        sessionId: prependId(sessionStore.data.sessionId),
        partnerId: sessionStore.data.partnerId
      })
    }
  )

  populateCDNField()
} else {
  console.debug(`[rum] [${new Date().toISOString()}]:`, 'init_rum_skip_by_env')
}

sessionStore.onDataChange(() => {
  Ya.Rum.setVars({
    '-service': sessionStore.data.service,
    '-env': sessionStore.data.env,
    '-version': sessionStore.data.version,
    '-platform': sessionStore.data.platformType,
    '-additional': JSON.stringify({
      parentRequestId: prependId(sessionStore.data.parentRequestId),
      platformVendor: sessionStore.data.platformVendor,
      sessionId: prependId(sessionStore.data.sessionId),
      partnerId: sessionStore.data.partnerId
    })
  })
})

/** asyncronally populate `YaStaticRegion` global variable */
function populateCDNField() {
  const nearestScriptElem = document.createElement('script')
  nearestScriptElem.src = 'https://yastatic.net/nearest.js'
  nearestScriptElem.crossOrigin = 'anonymous'
  nearestScriptElem.async = true
  document.head.appendChild(nearestScriptElem)
}
